import { ReactNode, useCallback } from "react";
import { useNavigate } from "react-router";

import * as styles from "./index.module.scss";

interface NavBarProps {
  title: string;
  fallbackPath?: string;
  left?: ReactNode;
  right?: ReactNode;
  onBack?: () => void;
}

export function NavBar({
  title,
  fallbackPath = "/",
  left,
  right,
  onBack,
}: NavBarProps) {
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    if (onBack) {
      onBack();
      return;
    }
    if (!document.referrer || window.history.length <= 2) {
      void navigate(fallbackPath);
    } else {
      navigate(-1);
    }
  }, [navigate, fallbackPath, onBack]);

  return (
    <header className={styles.navBar}>
      {left !== undefined ? (
        <div className={styles.navBarLeft}>{left}</div>
      ) : (
        <button
          type="button"
          aria-label="返回"
          className={styles.navBarBack}
          onClick={handleBack}
        >
          <svg
            viewBox="0 0 24 24"
            width="22"
            height="22"
            aria-hidden="true"
            focusable="false"
          >
            <path
              d="M15 5l-7 7 7 7"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}
      <h1 className={styles.navBarTitle}>{title}</h1>
      {!!right && <div className={styles.navBarRight}>{right}</div>}
    </header>
  );
}
